import { render, staticRenderFns } from "./basicTab.vue?vue&type=template&id=72d9b6a6&scoped=true&"
import script from "./basicTab.vue?vue&type=script&lang=js&"
export * from "./basicTab.vue?vue&type=script&lang=js&"
import style0 from "./basicTab.vue?vue&type=style&index=0&id=72d9b6a6&scoped=true&lang=scss&"
import style1 from "./basicTab.vue?vue&type=style&index=1&id=72d9b6a6&scoped=true&lang=scss&"
import style2 from "./basicTab.vue?vue&type=style&index=2&id=72d9b6a6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d9b6a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72d9b6a6')) {
      api.createRecord('72d9b6a6', component.options)
    } else {
      api.reload('72d9b6a6', component.options)
    }
    module.hot.accept("./basicTab.vue?vue&type=template&id=72d9b6a6&scoped=true&", function () {
      api.rerender('72d9b6a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaImport/components/SiBooking/tabs/basicTab.vue"
export default component.exports